import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '../../components/auth/ProtectedRoute';

const AiDocuments = lazy(() => import('../AI/AiDocuments'));

export const aiRoutes = (
    <React.Fragment key="ai">
        <Route element={<ProtectedRoute permission="ai.document.view" />}>
            <Route path="/ai-documents" element={<AiDocuments />} />
        </Route>
    </React.Fragment>
);
